module.exports = __webpack_public_path__ + "static/media/services-bg-3.6fc5afe4.webp";